declare global {
    interface Date {
        stripTimezone(): Date;
        isToday(): boolean;
    }
}

Date.prototype.stripTimezone = function(): Date {
    return new Date(this.getTime() - this.getTimezoneOffset() * 60000);
}

Date.prototype.isToday = function(): boolean {
    const now = new Date().stripTimezone();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).stripTimezone();
    const thisStripped = this.stripTimezone();
    
    return thisStripped.getFullYear() === today.getFullYear() &&
           thisStripped.getMonth() === today.getMonth() &&
           thisStripped.getDate() === today.getDate();
}

export {};